module.exports = "https://cdn.realtymogul.com/static/media/icon_groundup.583c213d.svg";